import { Divider, Stack, Typography } from '@mui/material';

import { defaultAppTheme } from 'styles/mui_app_theme/defaultAppTheme';

import { Certification, ComponentRecord, ComponentRecordStatus } from 'models';
import Icon from 'components/icons/Icon';
import ButtonToOpenDialog from 'app/widgets/dialogs/ButtonToOpenDialog';
import ComponentRecordReadingForm from 'app/gizmos/component_record/reading/ReadingForm';

import ComponentRecordProvider from 'app/providers/ComponentRecordProvider';
import ComponentReadingProvider from 'app/providers/ComponentReadingProvider';
import { useParams } from 'react-router';
import CertificationRecordForm from './CertificationRecordForm';
import CreateCertificate from './CreateEditCertification';
import { useState } from 'react';
import CertificationDataProvider from './CertificationDataProvider';
import CertificationRecordsProvider from './CertificationRecordsProvider';
import CreateEditCertificationRecord from './CreateEditCertificationRecord';
import ShowCertificationRecords from './ShowCertificationRecords';




const CertificationCard =
({
    certification
} : {
    certification?: Certification,
}) =>
{

    const [ closeDialog, setCloseDialog ] = useState<boolean>(false);

	
	return (
		
        <Stack
        justifyContent='center'
        alignItems='center'
    >
        
        <Typography
            variant='h6'
            sx={{
                padding: 0,
                textAlign: 'center',
                fontSize: '15px',
            }}
        >
            {certification.name}
        </Typography>
        
        <Typography
            variant='subtitle1'
            sx={{
                padding: 0,
                opacity: .2,
                fontSize: '13px',
            }}
        >
            {certification.certification_for}
        </Typography>
        
        {
            (certification?.category)
            &&
            <Typography
                sx={{
                    opacity: 1.6,
                }}
            >
                {certification?.type}
            </Typography>
        }
        
        <CertificationDataProvider certification = {certification}>
        <ButtonToOpenDialog
            button_variant='text'
            dialog_title={`Edit Certificate Details`}
            dialog_submit_text='Save Changes'
            dialog_dismiss_text='Revert'
            dialog_content={<CreateCertificate closeDialog={closeDialog}
            setCloseDialog={setCloseDialog}/>}
            button_content='Edit Certificate'
            startIcon={<Icon of='edit' size='24'/>}
            
            closeDialog={closeDialog}
        />
        </CertificationDataProvider>




        {/* this is to add certification records */}

        <CertificationRecordsProvider certification={certification}>

            <ButtonToOpenDialog
                button_variant='text'
                dialog_title={`Add Certification Record`}
                button_content='Add New Certification Record'
                dialog_content={<CreateEditCertificationRecord closeDialog={closeDialog}
                setCloseDialog={setCloseDialog}/>}
                
                closeDialog={closeDialog}
                sx={{
                    textTransform:'none',
                    textDecoration: 'underline',
                }}
            />


            <ButtonToOpenDialog
                button_variant='text'
                dialog_title={`AView Existing Records`}
                button_content='View Existing Records'
                dialog_content={<ShowCertificationRecords certification={certification}  
                setCloseDialog={setCloseDialog}/>}
                closeDialog={closeDialog}
                sx={{
                    textTransform:'none',
                    textDecoration: 'underline',
                }}
            />


                

        </CertificationRecordsProvider>




        
    </Stack>

	)
};


export default CertificationCard;